var map = {
	"./font/fons_1.otf": "u5Zg",
	"./font/fons_2.otf": "Y/2f",
	"./font/fons_3.ttf": "bO7M",
	"./font/huakang.ttf": "p/5A",
	"./font/pan.ttf": "ZKr+",
	"./font/siyuanH.otf": "dbAB",
	"./font/siyuanS.otf": "h4iB",
	"./greytabbt.png": "qRem",
	"./logo.png": "7Otq",
	"./tabbt2025_1.png": "lpQ/",
	"./tabbt2025_2.png": "sjHI",
	"./xi_1.jpg": "LLjp",
	"./xi_11.jpg": "7IBj",
	"./xi_12.jpg": "rxnq",
	"./xi_13.jpg": "Y5uz",
	"./xi_14.jpg": "/X3d",
	"./xi_15.jpg": "Uomv",
	"./xi_2.jpg": "R5SV",
	"./xi_3.jpg": "/p2Q",
	"./xi_4.jpg": "hKXI",
	"./xi_5.jpg": "5uy6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1